import { useState } from "react";
import { IconMapPin, IconPhone, IconMail } from "./Icons";
import { STORE_IMAGES } from "../data/watches";

const StoreSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section id="contact" className="store-section">
      <div className="store-gallery">
        <div className="store-gallery-main">
          {STORE_IMAGES.map((img, i) => (
            <img
              key={i}
              src={img.src}
              alt={img.alt}
              className={`store-gallery-main-img ${activeIndex === i ? "active" : ""}`}
              loading={i === 0 ? "eager" : "lazy"}
            />
          ))}
        </div>
        <div className="store-gallery-thumbs">
          {STORE_IMAGES.slice(1).map((img, i) => {
            const realIndex = i + 1;
            return (
              <button
                key={realIndex}
                type="button"
                className={`store-gallery-thumb ${activeIndex === realIndex ? "active" : ""}`}
                onClick={() => setActiveIndex(realIndex)}
                aria-label={`View ${img.alt}`}
                aria-pressed={activeIndex === realIndex}
              >
                <img src={img.src} alt={img.alt} loading="lazy" />
              </button>
            );
          })}
        </div>
      </div>
      <div className="store-content">
        <div className="section-label">Visit Us</div>
        <h2 className="store-title">Our Boutique</h2>
        <p className="store-text">
          Experience our curated collection in person. Our team of experienced
          professionals is ready to assist. Whether you're looking to buy, sell,
          or trade-in, we provide personalized services in a classy and
          comfortable setting.
        </p>
        <div className="store-info">
          <div className="store-info-item">
            <IconMapPin /> Plaza Blok M, Lantai 2, Unit 2.24-2.25, Jl. Bulungan
            No.76, Jakarta Selatan 12130
          </div>
          <div className="store-info-item">
            <IconPhone /> +62 851 7822 8989
          </div>
          <div className="store-info-item">
            <IconMail /> info@legacytimepieces.id
          </div>
          <div className="store-info-item" style={{ marginTop: 8 }}>
            <span className="store-hours-label">Hours</span>
            <span style={{ marginLeft: 4 }}>Mon – Sat, 11AM – 6PM WIB</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoreSection;
